export interface Testimonial {
  id: number
  quote: string
  name: string
  role: string
}

// EDITOR NOTE (not rendered on the live page):
// These are empty placeholders. Replace every entry with verified customer feedback
// before publishing. Do not invent names, schools, ratings, or results.
// To hide the whole section until real reviews exist, set `showTestimonials: false` in data/site.ts.
export const testimonials: Testimonial[] = [
  { id: 1, quote: 'Add verified teacher testimonial here.', name: 'Teacher name', role: 'Grade level or role' },
  { id: 2, quote: 'Add verified teacher testimonial here.', name: 'Teacher name', role: 'Grade level or role' },
  { id: 3, quote: 'Add verified teacher testimonial here.', name: 'Teacher name', role: 'Grade level or role' },
  { id: 4, quote: 'Add verified teacher testimonial here.', name: 'Teacher name', role: 'Grade level or role' },
  { id: 5, quote: 'Add verified teacher testimonial here.', name: 'Teacher name', role: 'Grade level or role' },
  { id: 6, quote: 'Add verified teacher testimonial here.', name: 'Teacher name', role: 'Grade level or role' },
]
